webpackJsonp([215163933632717],{

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeNavFooter = __webpack_require__(110);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _ShareExhibit = __webpack_require__(92);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Conclusion = function Conclusion(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: 'title__page' },
	        'Conclusion'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'The ',
	              _react2.default.createElement(
	                'em',
	                null,
	                '2020 Scorecard'
	              ),
	              ' offers the latest available federal data on the state of the U.S. health system before it headed into the most severe public health crisis and economic collapse in modern times. '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide section__content__bulleted__regular' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'It also highlights health system weaknesses that have left the U.S. far less prepared than other high-income countries to cope with public health threats like COVID-19. These weaknesses include:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'a health care delivery system that is highly unequal in its care of people of color and those with low and moderate incomes.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'an insurance system that still leaves millions without coverage.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'exorbitant commercial insurance prices that fuel growth in health spending and expose people to high premiums and deductibles, even as many make wage concessions to keep their employer benefits.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'an inadequate primary care system.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'declining life expectancy.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Some regions lag even further.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Scorecard also highlights the fact that the U.S. health system is characterized by considerable geographic variation in each of these areas. Some regions of the U.S. not only lag other regions on health performance indicators, but they also lag other economically advanced countries even further than national averages suggest.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'For example, uninsured rates ranged from 4 percent of the adult population in the District of Columbia and Massachusetts to a high of 24 percent in Texas. These differences reflect demographic differences and U.S. immigration policy, but also political choices in the implementation of federal law. If states continue to be left to address the coronavirus pandemic with little federal leadership, performance gaps will only widen as the health and economic crises persist.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'A looming court decision could further disrupt the health system.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Moreover, looming on the U.S. Supreme Court\u2019s 2020\u20132021 docket is ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'California v. Texas'
	              ),
	              ' (originally ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Texas v. Azar'
	              ),
	              '), in which a group of Republican-led states, with support from the Trump administration, is seeking to declare the entirety of the Affordable Care Act unconstitutional. Given the increased reliance of Americans on Medicaid and the marketplaces in the wake of job-based coverage losses over the past six months, a decision by the Supreme Court to overturn the law could result in more than 50 million uninsured people.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Because the ACA touches nearly every corner of the health system \u2014 not just coverage \u2014 such a decision also would trigger severe disruptions throughout a health system already severely compromised by the pandemic.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Daunting tasks for the federal government in 2021. '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The presidential election is just two months away. The federal government will face the daunting task of both controlling the pandemic and rebuilding a health system that had already been underperforming and unequal. The collection and analysis of new data on the effects of the pandemic will be critical to the ability of federal and state governments to craft evidence-based policy to move the health system forward and bring lagging states closer to the front of the pack.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We have amassed the most recent federal data as a baseline, but they are egregiously lagged. Timely data are needed in the critical areas of insurance coverage, racial and ethnic inequity in access and care, causes of mortality and life expectancy, provider performance during the pandemic, and more. And this information is needed quickly.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-16',
	            className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'National gains if all states achieved top rates* of performance'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-16-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                '* Performance benchmarks set at the level achieved by the top-performing state with available data for this indicator.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  'a'
	                ),
	                'Estimate based on working-age population, ages 18\u201364, with employer-sponsored insurance, and Medicare beneficiaries age 65 and older.'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-16',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges })
	  );
	};
	
	exports.default = Conclusion;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-conclusion-js-5e847d65171fb122d4a7.js